import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Badge } from '@mui/material';

import { ReactComponent as TruckIcon } from '@/assets/icons/generated-awbs-truck-icon.svg';

import { ButtonIconWrapper, ButtonLabel, ButtonText, MenuButton } from '../SideMenu/styled';
import useSideMenuHoverPopover from '../SideMenu/useSideMenuHoverPopover';

interface GeneratedAwbsButtonProps {
  isExpanded: boolean;
  pendingCount: number;
  onClick: () => void;
}

const GeneratedAwbsButton: FC<GeneratedAwbsButtonProps> = ({
  isExpanded,
  pendingCount,
  onClick,
}) => {
  const { t } = useTranslation();
  const { handleMouseEnter, handleMouseLeave, hoverPopover, closePopover } =
    useSideMenuHoverPopover(t('Generated AWBs'), isExpanded);

  return (
    <>
      <MenuButton
        variant="text"
        isExpanded={isExpanded}
        data-testid="generated-awbs-button"
        onClick={() => {
          closePopover();
          onClick();
        }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{ overflow: 'visible' }}
      >
        <ButtonLabel>
          <ButtonIconWrapper isExpanded={isExpanded}>
            <TruckIcon />

            <ButtonText isExpanded={isExpanded}>{t('Generated AWBs')}</ButtonText>
          </ButtonIconWrapper>

          {pendingCount > 0 && (
            <Badge
              badgeContent={pendingCount}
              // @ts-ignore
              color="accent"
              data-testid="generated-awbs-badge"
              sx={{
                position: 'absolute',
                transition: 'all 0.4s linear',
                ...(isExpanded
                  ? { left: 'calc(100% - 4rem)', top: '1.25rem' }
                  : { left: '2rem', top: '0.5rem' }),

                '& > span': {
                  transition: 'all 0.3s linear',
                  fontSize: '0.625rem!important',
                  height: 'auto',
                  padding: isExpanded ? '0.25rem 0.625rem' : '0.25rem',
                },
              }}
            />
          )}
        </ButtonLabel>
      </MenuButton>

      {hoverPopover}
    </>
  );
};

export default GeneratedAwbsButton;
